import { render, staticRenderFns } from "./Saved.vue?vue&type=template&id=63f2c706"
import script from "./Saved.vue?vue&type=script&lang=js"
export * from "./Saved.vue?vue&type=script&lang=js"
import style0 from "./Saved.vue?vue&type=style&index=0&id=63f2c706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports